export default "__VITE_ASSET__ZzBWP6JB__"